export enum OmsOrdersGroupType {
  Draft = "Draft",
  NotScheduled = "NotScheduled",
  PartiallyScheduled = "PartiallyScheduled",
  Scheduled = "Scheduled",
  Dispatched = "Dispatched",
  OnHold = "OnHold",
  Completed = "Completed",
  Canceled = "Canceled"
}
